import { message, Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import { operationalFunction } from 'components/UIBuilder/SectionFunction/Common';
import * as globalFunction from 'util/GlobalFunction';
import * as lodash from 'lodash';

export function batchDelete({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  if (sectionComponent.child.current?.state.selectedRowKeys.length !== 0) {
    globalFunction.confirm({
      content: 'Do you want to delete these records?',
      okText: 'Delete',
      okType: 'danger',
      callback: function () {
        httpClient
          .post('Business/ApprovalAdviceNote/BatchDelete', sectionComponent.child.current?.state.selectedRowKeys)
          .then(({ data }) => {
            if (data.result) {
              sectionComponent.child.current?.setState({ selectedRowKeys: [] });
              setTimeout(() => {
                sectionComponent.child.current?.getSectionDataByDefault();
              }, config.setTimeoutMilliSecond);
            } else {
              globalFunction.handleResultError(data, pageComponent);
            }
          })
          .catch(function (error) {
            globalFunction.handleError(error, pageComponent);
          });
      }
    });
  } else {
    message.warning('You must select at least one advice note.');
  }
}

export function addFromTemplate({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  openAddFromTemplate({ component: pageComponent });
}

export function openAddFromTemplate({ component } = {}) {
  component.setState({ approvalAdviceNoteAddFromTemplateShow: true });
  component.approvalAdviceNoteAddFromTemplate.current?.setState({ activeKey: 0 });
  setTimeout(() => {
    component.approvalAdviceNoteAddFromTemplate.current?.formRef.current?.resetFields();
    component.approvalAdviceNoteAddFromTemplate.current?.additionalFormRef.current?.child.current?.setState({ defaultSelectedRowKeys: [], selectedRowKeys: [], approvalAdviceNoteTemplatePresetContentList: [] });
    setTimeout(() => {
      component.approvalAdviceNoteAddFromTemplate.current?.additionalFormRef.current?.child.current?.getApprovalAdviceNoteTemplateData();
      component.approvalAdviceNoteAddFromTemplate.current?.getApprovalAdviceNoteTemplatePresetDataSource();
      console.log(component.approvalAdviceNoteAddFromTemplate.current?.additionalFormRef.current?.child.current)
    }, config.setTimeoutMilliSecond);
  }, config.setTimeoutMilliSecond);
}

// 打开 Manage Folder 弹窗（XML: <button onClick="manageApprovalAdviceNoteFolder" />）
export function manageApprovalAdviceNoteFolder({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.child.current?.setState({ manageFolderShow: true });
  sectionComponent.child.current?.manageFolder.current?.getApprovalAdviceNoteFolderList();
}

// 在指定 Folder 下添加 AdviceNote
export function addApprovalAdviceNote({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ showModal: true, componentType: 'Create' });
  setTimeout(() => {
    let formData = parameter;
    sectionComponent.customForm.current?.formRef.current?.setFieldsValue(formData);
    sectionComponent.customForm.current?.setState({ formData });
  }, config.setTimeoutMilliSecond);
}

// 单个 Folder 折叠/展开
export function collapseFolder({ component, key } = {}) {
  let data = component.state.data.map((folder, i) => {
    if (folder.key === key) {
      if (folder.Collapsed !== true) {
        folder.Collapsed = true;
      } else {
        folder.Collapsed = false;
      }
    }
    return folder;
  });
  component.setState({ data });
}

// 收起所有 folder
export function collapseAllFolders({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let data = sectionComponent.child.current?.state.data.map((folder, i) => {
    folder.Collapsed = true;
    return folder;
  });
  sectionComponent.child.current?.setState({ data });
}

// 打开 ChangeFolder 弹窗
export function openChangeFolder({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  if (sectionComponent.child.current?.state.selectedRowKeys.length !== 0) {
    let data = [];
    sectionComponent.child.current?.state.data.map((folder, i) => {
      folder.ApprovalAdviceNoteList.map((ApprovalAdviceNote, j) => {
        if (sectionComponent.child.current?.state.selectedRowKeys.indexOf(ApprovalAdviceNote.key) >= 0) {
          data.push(lodash.cloneDeep(ApprovalAdviceNote));
        }
      })
    })

    sectionComponent.child.current?.setState({ changeFolderShow: true });

    httpClient
      .get('Business/ApprovalAdviceNoteFolder/GetSelectOptionList?approvalId=' + pageComponent.props.approvalId)
      .then(({ data }) => {
        if (data.result) {
          let componentDataSource = [];
          componentDataSource.ApprovalAdviceNoteFolderId = data.data;
          sectionComponent.child.current?.changeFolder.current?.setState({ componentDataSource });
          sectionComponent.child.current?.changeFolder.current?.formRef.current?.setFieldsValue({ 'ApprovalAdviceNoteFolderId': data.data[0].Value });
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  } else {
    message.warning('You must select at least one record.');
  }
}
